/*
 * O <html> tem `zoom: var(--app-zoom)` (ver theme.css). Com isso o layout inteiro é
 * desenhado em 100% e exibido menor.
 *
 * O efeito colateral: o que o JS mede na mão (event.clientX, getBoundingClientRect,
 * window.innerWidth) vem em pixel real da tela, enquanto um `style={{ left: "120px" }}`
 * é interpretado na unidade de dentro do zoom. Somar os dois direto erra pelo fator do
 * zoom. Divida a medida real por `getAppZoom()` antes de usá-la como px no CSS.
 */

export function getAppZoom() {
  if (typeof window === "undefined" || !document.documentElement) return 1;
  const raw = window.getComputedStyle(document.documentElement).zoom;
  const zoom = Number.parseFloat(raw);
  return Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
}

/** Converte uma medida em pixel real da tela para a unidade usada dentro do zoom. */
export function toCssPx(realPx) {
  return realPx / getAppZoom();
}
